import { z } from "zod";

export const CompanyListSearchFormSchema = z.object({
  companyName: z.string().optional(),
  address: z.string().optional(),
  companyCategories: z.array(z.enum(["shipper", "carrier"])).optional(),
});

export type CompanyListSearchFormSchemaType = z.infer<
  typeof CompanyListSearchFormSchema
>;
